import { Action, Transaction } from '@near-wallet-selector/core';
import JSBI from 'jsbi';
import { DEFAULT_GAS, WRAPPED_NEAR_ID } from '../../../constants';

export const builWithdrawNearActions = async (amount: JSBI) => {
  const actions = new Array<Action>();

  const withdrawAmount = amount.toString();

  actions.push({
    type: 'FunctionCall',
    params: {
      methodName: 'near_withdraw',
      args: {
        amount: withdrawAmount,
      },
      gas: DEFAULT_GAS,
      deposit: '1',
    },
  });

  // TBD: close wrapped account/return deposit

  return actions;
};

export const buildWithdrawNearTransaction = async (
  signerId: string,
  amount: JSBI
) => {
  const transaction: Transaction = {
    receiverId: WRAPPED_NEAR_ID,
    signerId,
    actions: await builWithdrawNearActions(amount),
  };

  return transaction;
};
